import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import type React from 'react'
import { useMemo } from 'react'
import { useFormatter } from '../../../../../../../api/useFormatter'

interface IProps {
  components: Gravitate.Order['component_paths']
  selectedMarket: string
}

export const DropSummaryCard: React.FC<IProps> = ({ components, selectedMarket }) => {
  const accentColor = 'var(--theme-error)'
  const textColor = 'error'
  const formatter = useFormatter({ marketOverride: selectedMarket })

  const groupedComponents = useMemo(() => {
    return components?.reduce((acc, c) => {
      return {
        ...acc,
        [c.product_name]: [...(acc[c.product_name] || []), c],
      }
    }, {}) as Record<string, Gravitate.Order['component_paths']>
  }, [components])

  return (
    <Horizontal
      style={{
        border: `1px solid ${accentColor}`,
        borderRadius: '4px',
        gap: '2em',
      }}
      className=' ml-3 p-4'
      height='auto'
      background='bg-2'
    >
      <Texto appearance={textColor} category='h5' className='pb-2'>
        DROPS
      </Texto>
      <Horizontal>
        {Object.entries(groupedComponents || {})?.map(([product, components]) => (
          <Vertical key={`drop-summary-card-${product}`} className='mr-3'>
            <Texto align='right' category='h5' weight='bold'>
              {formatter.formatVolume(
                components?.reduce((dropVolume, component) => dropVolume + component.volume, 0),
                true
              )}
            </Texto>
            <Texto align='right' weight={600} appearance={textColor}>
              {product}
            </Texto>
          </Vertical>
        ))}
      </Horizontal>
    </Horizontal>
  )
}
